import { render, staticRenderFns } from "./NewEditContent.vue?vue&type=template&id=326184e2&"
import script from "../../models/push-notifications/new-edit-content.ts?vue&type=script&lang=ts&"
export * from "../../models/push-notifications/new-edit-content.ts?vue&type=script&lang=ts&"
import style0 from "./NewEditContent.vue?vue&type=style&index=0&id=326184e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports